import { Logout } from './logout'
import { ChoosePlan } from './personal-info/choose-plan'
import { SessionContext } from '../../context/session-context'
import { cn } from '../../lib/utils'
import { EventBusActionType, EventBusEntityType, eventBusUtil } from '../../util/event-bus-util'
import { Dialog, DialogClose, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog'
import { X } from 'lucide-react'
import React, { useContext, useEffect } from 'react'

export const ChoosePlanModal = (): React.ReactElement => {
  const { showSubscriptionModal, toggleSubscriptionModal } = useContext(SessionContext)

  useEffect(() => {
    if (showSubscriptionModal) {
      eventBusUtil().emit({
        action: EventBusActionType.CREATE,
        entity: EventBusEntityType.PAYWALL,
        meta: {},
      })
    }
  }, [showSubscriptionModal])

  const handleOpenChange = (open: boolean): void => {
    if (!open) {
      toggleSubscriptionModal()
    }
  }

  return (
    <Dialog open={showSubscriptionModal} onOpenChange={handleOpenChange}>
      {/*
        A column with exactly one scrollport (the body), at every breakpoint — not just below
        `sm`. The overflow rules used to be `max-sm:`-prefixed, so on desktop the dialog was a
        `grid` clamped to 90vh with `overflow: visible`: anything past the clamp painted outside
        the box, and Radix's body scroll-lock meant the page behind it could not scroll either.
        Measured, that put the plan buttons out of reach at every viewport height at or below a
        1440x900 laptop's ~780px — i.e. exactly the laptops GH-909 was reported on. A `max-h`
        must always be paired with an `overflow`.

        `flex` (not `!flex`) is what displaces the primitive's `grid` — `cn()` is tailwind-merge,
        which resolves the two in its `display` group with this string last. The `!` modifier
        changes the group key, so `!flex` would leave `grid` in place.
      */}
      <DialogContent
        className={cn(
          'max-w-4xl rounded-2xl [&>button:last-child]:hidden flex flex-col sm:max-h-[90dvh]',
          'max-sm:inset-0 max-sm:top-0 max-sm:left-0 max-sm:translate-x-0 max-sm:translate-y-0 max-sm:h-full max-sm:w-full max-sm:max-w-none max-sm:rounded-none max-sm:p-4',
        )}
      >
        <DialogHeader className="flex flex-row items-center justify-between pb-4 shrink-0">
          <DialogTitle className="text-primary font-evogria text-4xl font-normal uppercase">Choose plan</DialogTitle>
          <DialogClose className="rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none text-ivory hover:text-gray-300">
            <X className="h-6 w-6" />
            <span className="sr-only">Close</span>
          </DialogClose>
        </DialogHeader>
        {/*
          Radix wraps the *Overlay* in react-remove-scroll and passes the content node in as a
          `shards` entry, so a scrollport nested inside `DialogContent` still takes wheel and
          touch while the body is locked. The one requirement is that it lives in here.
        */}
        <div data-testid="choose-plan-scrollport" className="py-4 flex-1 min-h-0 overflow-y-auto overscroll-contain">
          <ChoosePlan />
        </div>
        <DialogFooter className="border-t-0 shrink-0 pt-2">
          <Logout />
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
